import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import TopHeader from '../template/TopHeader';
import MobileSubmenu from '../shared/MobileSubmenu';
import { connect } from "react-redux";
import { marketingAction } from "../../_actions/marketing.actions";
import { SOCIAL_VISIBLE, MARKETING_HOME_VISIBLE, DISCOUNTS_VISIBLE } from "../../config/featureFlags";

class MarketingMobileView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAutomatedComms: true
        };
    }

    componentDidMount() {
        if (MARKETING_HOME_VISIBLE) return;
        this.getMarketingSetting();
    }

    getMarketingSetting = () => {
        let self = this;
        return self.props.dispatch(marketingAction.getMarketingSetting()).then((res) => {
            if (res.data.statusCode === 1) {
                if (res?.data?.responseData?.result.length > 0) {
                    let data = res?.data?.responseData?.result;
                    if ((data[0].salonConsent === 0 && data[0].selfEmpConsent === 1) ||
                        (data[0].salonConsent === 1 && data[0].selfEmpConsent === 0) ||
                        self.props?.isOwner === 1 ||
                        (data[0].salonConsent === 0 && data[0].selfEmpConsent === 0)) {
                        self.setState({ showAutomatedComms: true });
                    } else {
                        self.setState({ showAutomatedComms: false });
                    }
                }
            }
        });
    };

    // Opened below this menu, so their Back comes back here (goUp)
    handleNavClick = (url) => {
        this.props.history.push(url, { from: '/marketing-nav' });
    };

    render() {
        // The Marketing home lists every section, so it replaces this menu
        if (MARKETING_HOME_VISIBLE) return <Redirect to="/marketing-home" />;
        const navItems = [];

        navItems.push({
            id: 'campaigns',
            title: 'Campaigns',
            description: 'Email and SMS campaigns',
            url: '/marketing-campaigns',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><path d="m3 11 15-6v14l-15-6v-2Z" /><path d="M11.6 16.8a3 3 0 1 1-5.2-3" /><path d="M18 8a4 4 0 0 1 0 8" /></svg>
        });

        if (SOCIAL_VISIBLE) {
            navItems.push({
                id: 'social',
                title: 'Social',
                description: 'Instagram and TikTok posts',
                url: '/marketing-social',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" /></svg>
            });
        }

        navItems.push({
            id: 'journeys',
            title: 'Journeys',
            description: 'Multi-step client journeys',
            url: '/marketing-journeys',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="5" cy="6" r="2.4" /><circle cx="19" cy="18" r="2.4" /><path d="M7.4 6H15a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3H9a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3h7.6" /></svg>
        });

        navItems.push({
            id: 'loyalty',
            title: 'Loyalty',
            description: 'Stamp cards and points',
            url: '/marketing-loyalty',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" /></svg>
        });

        if (DISCOUNTS_VISIBLE) {
            navItems.push({
                id: 'discounts',
                title: 'Discounts',
                description: 'Codes for posts, emails and bookings',
                url: '/marketing-discounts',
                icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 8a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4z" /><path d="M9.5 14.5l5-5" /></svg>
            });
        }

        navItems.push({
            id: 'performance',
            title: 'Performance',
            description: 'Results and engagement',
            url: '/marketing-performance',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v16a2 2 0 0 0 2 2h16" /><path d="M7 14l4-4 3 3 5-6" /></svg>
        });

        navItems.push({
            id: 'communications',
            title: 'Communications',
            description: 'Reminders and custom emails',
            url: '/marketing',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
        });

        navItems.push({
            id: 'marketing-settings',
            title: 'Config',
            description: 'Manage your marketing settings',
            url: '/marketing-setting',
            icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" /></svg>
        });

        return (
            <div className="h_n">
                <div className="body_container cm_bg_white">
                    <TopHeader title="Marketing" headerButtonStatus={true} {...this.props} />
                    <MobileSubmenu items={navItems} onNavigate={this.handleNavClick} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(MarketingMobileView));
